import { Th as ChakraTh, Text } from '@chakra-ui/react'

export const Th = ({
  textAlign = 'center',
  bgColor = 'blue.500',
  color = 'white',
  children,
  ...props
}) => (
  <ChakraTh
    textAlign={textAlign}
    bgColor={'#378BBF'}
    color={color}
    py={2}
    px={0}
    {...props}
  >
    <Text fontSize="12px" fontWeight="normal" textTransform="capitalize">
      {children}
    </Text>
  </ChakraTh>
)
